import { FC } from 'react';
import { useParams } from 'react-router';
import { AssessmentStatus } from 'api/hooks/assessment/assessmentTypes';
import { useCheckAssessmentStatus } from 'api/hooks/common/useCheckAssessmentStatus';
import { MainQuestionAssessmentListTable } from './main-question-assessment-list-table';
import { MainQuestionAssessmentFilterSection } from './main-question-assessment-filter-section';

export const MainQuestionAssessment: FC = () => {
    const { assessmentId } = useParams();

    const assessmentStatus = useCheckAssessmentStatus({
        assessmentId: assessmentId ?? '',
        currentStatuses: [
            AssessmentStatus.ANALYSIS_IN_PROGRESS,
            AssessmentStatus.ASSURANCE_IN_PROGRESS,
        ],
    });

    return (
        <>
            <MainQuestionAssessmentFilterSection />
            <MainQuestionAssessmentListTable
                isReadOnly={assessmentStatus.isReadOnly}
            />
            {/* <BasicRowEditingGrid data={mainQuestionsData} /> */}
        </>
    );
};
